/**
 * sanitize.js — helpers de seguridad para render en el DOM.
 *
 * escapeHtml: neutraliza texto no confiable antes de interpolarlo en innerHTML
 *   o en el html: de SweetAlert2. Cubre el hallazgo C2 (XSS almacenado
 *   usuario->admin via texto de sugerencia y nombre de usuario).
 *
 * safeUrl: valida que una URL use esquema http(s) antes de meterla en src/href,
 *   bloqueando javascript:, data:, vbscript:, etc. Cubre el hallazgo M1
 *   (URLs de imagenes de una API externa sin validar esquema).
 */

export function escapeHtml(value) {
  if (value == null) return "";
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

const BLOCKED_TAGS = "script, style, iframe, object, embed, link, meta, base, form";

/**
 * sanitizeHtml: limpia HTML generado a partir de contenido subido (ej. un .md
 * renderizado con marked) antes de meterlo en innerHTML: quita etiquetas
 * ejecutables, atributos on* y URLs con esquemas peligrosos.
 */
export function sanitizeHtml(html) {
  const doc = new DOMParser().parseFromString(String(html ?? ""), "text/html");
  doc.querySelectorAll(BLOCKED_TAGS).forEach(el => el.remove());
  doc.body.querySelectorAll("*").forEach(el => {
    for (const attr of [...el.attributes]) {
      const name = attr.name.toLowerCase();
      if (name.startsWith("on")) el.removeAttribute(attr.name);
      else if ((name === "href" || name === "src") && /^\s*(javascript|data|vbscript):/i.test(attr.value)) el.removeAttribute(attr.name);
    }
  });
  return doc.body.innerHTML;
}

export function safeUrl(value) {
  if (value == null) return "";
  const url = String(value).trim();
  return /^https?:\/\//i.test(url) ? url : "";
}
